require("intersection-observer"); // polyfill needed for VueObserveVisibility in Safari / IE
import "array-flat-polyfill"; // polyfill needed for Array.prototype.flat in old Microsoft Browsers
import BenjaminApp from "./BenjaminApp.vue";
import { sync } from "vuex-router-sync";
import Vue from "vue";
import VueI18n from "vue-i18n";
import VueWaypoint from "vue-waypoint";
import VueObserveVisibility from "vue-observe-visibility";
import VueScrollTo from "vue-scrollto";
import Vue2Filters from "vue2-filters";

const { messages } = require("./i18n/index")
const { dateTimeFormats } = require("./i18n/dateTimeFormats");
const Dialog = require("buefy/dist/components/dialog").default;
const Loading = require("buefy/dist/components/loading").default;

Vue.use(VueI18n);
Vue.use(VueWaypoint);
Vue.use(VueScrollTo);
Vue.use(Vue2Filters);
Vue.use(VueObserveVisibility);
Vue.use(Dialog);
Vue.use(Loading);

import store from "./store";
import router from "./router";
sync(store, router);

const i18n = new VueI18n({
    dateTimeFormats,
    locale: store.state.i18n.locale,
    messages
});

new Vue({
    i18n,
    render: h => h(BenjaminApp),
    router,
    store,
}).$mount("#benjamin-app");